





































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import TimeSelect from "../time-type-select.vue";
import { CdrRenkou } from "@/request/kanban";
@Component({
  components: {
    TimeSelect,
  },
})
export default class KanbanCdrRenkou extends Vue {
  @Prop()
  private selectedHospitals: any;
  @Prop()
  private center: any;
  private timeType: any = {
    人口统计: "全部时间",
  };
  private customTime: any = {
    人口统计: [],
  };
  private message: any = {
    年龄分布: {},
    地区分布: {},
    西医疾病: {},
    中医疾病: {},
    中医证型: {},
    中医体质: {},
  };
  private nianlingBar: any = {
    color: ["#6492ed"],
    xAxis: {
      type: "category",
      data: [],
    },
    yAxis: {
      type: "value",
    },
    grid: {},
    tooltip: {},
    series: [
      {
        type: "bar",
        data: [],
      },
    ],
  };
  private xingbiePie: any = {
    tooltip: {},
    color: ["#75DDB5", "#74A0FC"],
    grid: {},
    series: [
      {
        type: "pie",
        data: [],
        radius: ["50%", "70%"],
        center: ["50%", "40%"],
        label: {
          formatter: (params: any) => {
            return params.percent + "%" + "\n" + params.name;
          },
          fontSize: 14,
        },
      },
    ],
  };
  private jibingType: any = "西医疾病";
  private jibingfenbuBar: any = {
    title: {
      text: this.jibingType,
      textStyle: {
        color: "#666",
        fontSize: "16",
        fontWeight: "normal",
      },
      textAlign: "center",
      left: "center",
      top: "20",
    },
    xAxis: {
      type: "category",
      data: [],
    },
    tooltip: {},
    yAxis: {},
    grid: {
      left: "3%",
    },
    series: [
      {
        type: "bar",
        data: [],
        label: {
          show: true,
        },
      },
    ],
  };
  /**
   * @description 获得人口统计数据
   */
  private fetchRenkou() {
    const ids: any = [];
    this.selectedHospitals.forEach((h: any) => {
      ids.push(h.hospital_id);
    });
    const params: any = {
      hospital_ids: ids,
      project_id: this.center.project_id,
    };
    if (this.timeType["人口统计"] !== "自定义") {
      params["统计时间"] = this.timeType["人口统计"];
    } else {
      params["开始时间"] = this.customTime["人口统计"][0];
      params["结束时间"] = this.customTime["人口统计"][1];
    }
    CdrRenkou(this, params).then((data: any) => {
      this.message = data;
      // console.log(data);
      this.createNianlingBar();
      this.createXingbiePie();
      this.createJibingBar();
    });
  }
  /**
   * @description 时间改变
   */
  private timeChange(type) {
    this.timeType["人口统计"] = type;
    this.fetchRenkou();
  }
  /**
   * @description 时间自定义改变
   */
  private customTimeChange(val) {
    this.customTime["人口统计"] = val;
    this.fetchRenkou();
  }
  /**
   * @description 创建年龄柱状图
   */
  private createNianlingBar() {
    this.nianlingBar["series"][0]["data"] = this.message["年龄分布"]["data"];
    this.nianlingBar["xAxis"]["data"] = this.message["年龄分布"]["title"];
  }
  /**
   * @description 创建性别饼图
   */
  private createXingbiePie() {
    this.message["性别分布"]["data"].map((i: any) => {
      i.name = i.title;
    });
    this.xingbiePie.series[0].data = this.message["性别分布"]["data"];
  }
  /**
   * @description 创建疾病分布饼图
   */
  private createJibingBar() {
    this.jibingfenbuBar["title"]["text"] = this.jibingType + "分布";
    this.jibingfenbuBar["series"][0]["data"] = this.message[this.jibingType][
      "data"
    ];
    this.jibingfenbuBar["xAxis"]["data"] = this.message[this.jibingType][
      "name"
    ];
  }
  /**
   * @description 改变疾病诊断类型
   */
  private changeJibingType(type) {
    this.jibingType = type;
    this.createJibingBar();
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.$watch(
      () => {
        return this.selectedHospitals;
      },
      () => {
        this.fetchRenkou();
      },
      {
        immediate: true,
      }
    );
  }
}
